import React from "react";
import { IconButton, TableRow, TableCell, makeStyles } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { ThemeType } from "@theme";
import { TimereportRowSourceMark } from "@components/TimereportRowSource/TimereportRowSourceMark";

type Props = {
  title: string;
  periodTitle: string;
  from: string;
  to: string;
  periods: Array<{ from: string; to: string }>;
  onEdit: () => void;
  onDelete: () => void;
  /** Where the shift was reported (ADR-0008). Absent on rows written before it was recorded. */
  source?: string | null;
  sourceId?: string | null;
  sourceUrl?: string | null;
  canEdit?: boolean;
  canDelete?: boolean;
};

export function PeriodTimeRow(props: Props) {
  const classes = useStyles({});

  return (
    <>
      <TableRow className={classes.rowWrap}>
        <TableCell>
          <strong>{props.title}</strong>
        </TableCell>
        {/*
          The shift is the row, so the mark goes here and not on the passive or
          active periods below it — those are detail inside one reported shift,
          reported by whoever reported the shift.
        */}
        <TableCell>
          <span className={classes.timeLine}>
            <TimereportRowSourceMark
              source={props.source}
              sourceId={props.sourceId}
              sourceUrl={props.sourceUrl}
            />
            <span>{props.from}</span>
          </span>
        </TableCell>
        <TableCell>{props.to}</TableCell>
        <TableCell>
          {props.canEdit !== false && (
            <IconButton onClick={() => props.onEdit()} color="default" size="small">
              <Edit />
            </IconButton>
          )}

          {props.canDelete !== false && (
            <IconButton onClick={() => props.onDelete()} color="default" size="small">
              <Delete />
            </IconButton>
          )}
        </TableCell>
      </TableRow>

      {props.periods.map((period, i) => (
        <TableRow key={i}>
          <TableCell style={{ paddingLeft: 32 }}>{props.periodTitle}</TableCell>
          <TableCell>{period.from}</TableCell>
          <TableCell>{period.to}</TableCell>
          <TableCell />
        </TableRow>
      ))}
    </>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  rowWrap: {
    transition: "all .3s ease",
    "& button": {
      transition: "all .3s ease;",
      opacity: 0
    },
    "&:hover": {
      background: "#eee",
      "& button": {
        opacity: 1
      }
    }
  },
  timeLine: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6
  }
}));
